var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasurementCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Measurement Mouse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0704 18.1604C26.6071 18.6971 26.6168 19.5586 26.0918 20.0835L21.3384 24.837C20.8135 25.3619 19.952 25.3522 19.4153 24.8155L1.86424 7.77426C1.63503 7.54505 1.50285 7.23758 1.49678 6.91949C1.49072 6.60141 1.61126 6.29876 1.83189 6.07813L10.3319 4.07813C10.8568 3.5532 11.9219 4.01191 12.4586 4.5486L26.0704 18.1604ZM16.6718 8.76178L15.008 10.4256ZM14.0791 6.16905L11.5834 8.66472ZM19.2645 11.3545L16.7689 13.8502ZM24.45 16.54L21.9543 19.0356ZM21.8572 13.9472L20.1935 15.611Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6718 8.76178L15.008 10.4256M14.0791 6.16905L11.5834 8.66472M19.2645 11.3545L16.7689 13.8502M24.45 16.54L21.9543 19.0356M21.8572 13.9472L20.1935 15.611M26.0704 18.1604C26.6071 18.6971 26.6168 19.5586 26.0918 20.0835L21.3384 24.837C20.8135 25.3619 19.952 25.3522 19.4153 24.8155L1.86424 7.77426C1.63503 7.54505 1.50285 7.23758 1.49678 6.91949C1.49072 6.60141 1.61126 6.29876 1.83189 6.07813L10.3319 4.07813C10.8568 3.5532 11.9219 4.01191 12.4586 4.5486L26.0704 18.1604Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#50B786"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementCursor);
export default __webpack_public_path__ + "static/media/measurement-cursor.6b12c56be0c2ec4b017f35c0d9cda6bc.svg";
export { ForwardRef as ReactComponent };